export const getArrayOfClass = (element: HTMLElement, name: string): HTMLElement[] => {
	if (!element) {
		return [];
	}
	return Array.from(element.querySelectorAll("." + name));
};
